import { UserProfile } from "@/types/user.types";

const { ADMINISTRATOR, MANAGER, ATTENDANT, REPRESENTATIVE, OPERATIONS } = UserProfile;

export const DASHBOARD_SERVICE_PERMISSIONS = {
  CREATE: [],
  EDIT: [],
  DELETE: [],
};

export const DASHBOARD_SALES_PERMISSIONS = {
  CREATE: [],
  EDIT: [],
  DELETE: [],
};

export const DASHBOARD_MANAGERIAL_PERMISSIONS = {
  CREATE: [],
  EDIT: [],
  DELETE: [],
};

export const CHAT_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS, ATTENDANT, REPRESENTATIVE],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS, ATTENDANT, REPRESENTATIVE],
  DELETE: [ADMINISTRATOR],
};

export const CONTACT_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS, ATTENDANT, REPRESENTATIVE],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS, ATTENDANT, REPRESENTATIVE],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
};

export const ORDER_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS, ATTENDANT, REPRESENTATIVE],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  VIEW: [MANAGER, ADMINISTRATOR, OPERATIONS, ATTENDANT, REPRESENTATIVE],
  PRINT: [MANAGER, ADMINISTRATOR, OPERATIONS, ATTENDANT, REPRESENTATIVE],
};

export const PRODUCT_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
};

export const PRODUCT_VARIATION_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
};

export const CATEGORIES_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
};

export const PRODUCT_VARIATION_IMAGES_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
};

export const COMPANY_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR],
  EDIT: [MANAGER, ADMINISTRATOR],
  DELETE: [MANAGER, ADMINISTRATOR],
};

export const PLATFORM_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
};

export const USERS_PERMISSIONS = {
  CREATE: [ADMINISTRATOR],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [ADMINISTRATOR],
};

export const WORKFLOW_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR],
};

export const PLAN_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR],
};

export const SUBSCRIBE_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR],
  EDIT: [MANAGER, ADMINISTRATOR],
  DELETE: [MANAGER, ADMINISTRATOR],
};

export const TALK2PAY_PERMISSIONS = {
  CREATE: [ADMINISTRATOR],
  VIEW: [ADMINISTRATOR],
};

export const LIST_PRICE_PERMISSIONS = {
  EDIT: [ADMINISTRATOR, OPERATIONS, MANAGER],
};

export const RENEW_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR],
  EDIT: [MANAGER, ADMINISTRATOR],
  DELETE: [MANAGER, ADMINISTRATOR],
};

export const CAMPAIGN_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  STATS: [MANAGER, ADMINISTRATOR],
};

export const COVERAGE_AREA_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR],
  EDIT: [MANAGER, ADMINISTRATOR],
  DELETE: [MANAGER, ADMINISTRATOR],
  STATS: [MANAGER, ADMINISTRATOR],
};

export const SERVICE_QUEUE_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR],
  EDIT: [MANAGER, ADMINISTRATOR],
  DELETE: [MANAGER, ADMINISTRATOR],
};

export const NOTIFICATION_PERMISSIONS = {
  CREATE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  EDIT: [MANAGER, ADMINISTRATOR, OPERATIONS],
  DELETE: [MANAGER, ADMINISTRATOR, OPERATIONS],
  STATS: [MANAGER, ADMINISTRATOR],
};
